<app-impersonate-organisation
  [organisationId]="customerId"
  [showDialog]="showImpersonateDialog"
  (onClose)="onImpersonateClose()"
>
</app-impersonate-organisation>

<div class="profile-header">
  <div class="flex-grow-1 content-header" style="align-content: space-evenly">Customer Profile</div>
  <div class="flex-shrink-1">
    <p-button
      *ngIf="companyInfoURL"
      label="Customer Information"
      styleClass="information-button"
      (click)="gotoCustomerInformation()"
    >
    </p-button>

    <p-button
      label="Impersonate Customer"
      styleClass="information-button"
      (click)="impersonateCustomer()"
      [disabled]="isImpersonating"
    >
    </p-button>
  </div>
</div>

<div class="container-secondary d-grid grid-gap-15">
  <div style="display: flex; flex-wrap: wrap; grid-gap: 15px">
    <div style="flex-grow: 99; flex-shrink: 1; flex-basis: 400px">
      <app-customer-profile-detail [customerId]="customerId"></app-customer-profile-detail>
    </div>
    <div style="flex-grow: 1; flex-shrink: 1; flex-basis: 400px">
      <app-customer-profile-activity [customerId]="customerId"></app-customer-profile-activity>
    </div>
  </div>
</div>

<div class="data-container">
  <p-tabView
    #tabviewMain
    class="no-padding-tabview no-rounded-top-tabview"
    [style]="{ height: '100%', 'border-radius': '10px', 'overflow-x': 'hidden' }"
    [(activeIndex)]="activeIndex"
  >
    <p-tabPanel header="All Orders">
      <customer-profile-all-jobs [customerId]="customerId"></customer-profile-all-jobs>
    </p-tabPanel>

    <p-tabPanel header="Unallocated">
      <app-customer-orders-filter
        [structure]="structureData"
        (filterChanged)="onOrdersFilterChanged($event, JobProfileTab.unallocatedJobs)"
      ></app-customer-orders-filter>
      <jobs-information-list
        [isCustomerView]="true"
        [jobs]="jobsByStatus[JobProfileTab.unallocatedJobs]"
        [subWord]="'Unallocated'"
        [busy]="isBusy"
      ></jobs-information-list>
    </p-tabPanel>

    <p-tabPanel header="Allocated">
      <app-customer-orders-filter
        [structure]="structureData"
        (filterChanged)="onOrdersFilterChanged($event, JobProfileTab.allocatedJobs)"
      ></app-customer-orders-filter>
      <jobs-information-list
        [isCustomerView]="true"
        [jobs]="jobsByStatus[JobProfileTab.allocatedJobs]"
        [subWord]="'Allocated'"
        [busy]="isBusy"
      ></jobs-information-list>
    </p-tabPanel>

    <p-tabPanel header="Live Now">
      <app-customer-orders-filter
        [structure]="structureData"
        (filterChanged)="onOrdersFilterChanged($event, JobProfileTab.liveJobs)"
      ></app-customer-orders-filter>
      <jobs-information-list
        [isCustomerView]="true"
        [jobs]="jobsByStatus[JobProfileTab.liveJobs]"
        [subWord]="'Live'"
        [busy]="isBusy"
      ></jobs-information-list>
    </p-tabPanel>

    <p-tabPanel header="Cancelled">
      <app-customer-orders-filter
        [structure]="structureData"
        (filterChanged)="onOrdersFilterChanged($event, JobProfileTab.cancelledJobs)"
      ></app-customer-orders-filter>
      <jobs-information-list
        [isCustomerView]="true"
        [jobs]="jobsByStatus[JobProfileTab.cancelledJobs]"
        [subWord]="'Cancelled'"
        [busy]="isBusy"
      ></jobs-information-list>
    </p-tabPanel>

    <p-tabPanel header="Closed">
      <app-customer-orders-filter
        [structure]="structureData"
        (filterChanged)="onOrdersFilterChanged($event, JobProfileTab.closedJobs)"
      ></app-customer-orders-filter>
      <jobs-information-list
        [isCustomerView]="true"
        [jobs]="jobsByStatus[JobProfileTab.closedJobs]"
        [subWord]="'Closed'"
        [busy]="isBusy"
      ></jobs-information-list>
    </p-tabPanel>

    <p-tabPanel header="Completed">
      <app-customer-orders-filter
        [structure]="structureData"
        (filterChanged)="onOrdersFilterChanged($event, JobProfileTab.completedJobs)"
      ></app-customer-orders-filter>
      <jobs-information-list
        [isCustomerView]="true"
        [jobs]="jobsByStatus[JobProfileTab.completedJobs]"
        [subWord]="'Completed'"
        [busy]="isBusy"
      ></jobs-information-list>
    </p-tabPanel>

    <p-tabPanel header="Users">
      <app-customer-users-info
        [customerId]="customerId"
        [currentCallerUserId]="callerUserId"
        [structure]="structureData"
      ></app-customer-users-info>
    </p-tabPanel>
  </p-tabView>

  <app-customer-call-stats [customerId]="customerId"></app-customer-call-stats>
</div>
